
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-compressor",
      function () {
        return require("private-next-pages/video-compressor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-compressor"])
      });
    }
  